import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    width: '100%',
    minHeight: '100vh',
    gap: theme.spacing(20),
    background: theme.palette.primary.main,
    [theme.breakpoints.only('md')]: {
      gridTemplateColumns: '1fr 1fr',
    },
    [theme.breakpoints.up('lg')]: {
      gridTemplateColumns: '5fr 7fr',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(4),
    },
  },
  leftPanel: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: theme.spacing(12),
    paddingBlock: theme.spacing(6),
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(4, 3),
    },
  },
  hexTop: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: 400,
    opacity: 0.9,
    '& path': { stroke: `${theme.palette.secondary.dark} !important` },
  },
  hexBottom: {
    position: 'absolute',
    bottom: 0,
    right: 0,
    width: 400,
    opacity: 0.9,
    transform: 'rotate(180deg)',
    '& path': { stroke: `${theme.palette.secondary.dark} !important` },
  },
  logo: {
    width: 270,
    marginBottom: theme.spacing(4),
    position: 'relative',
    zIndex: 1,
  },
  welcomeText: {
    color: theme.palette.white,
    textAlign: 'justify',
    maxWidth: '100%',
    position: 'relative',
    zIndex: 1,
    fontSize: theme.typography.h4.fontSize,
  },
  rightPanel: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
  card: {
    background: theme.palette.white,
    borderRadius: 16,
    boxShadow: '0px 4px 24px rgba(0,0,0,0.12)',
    padding: theme.spacing(6, 5),
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      height: 'auto',
    },
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(4, 3),
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    zIndex: 1,
  },
}))

export default useStyles
